import React, { useContext } from "react";
import Header from "../Header/Header";
import { AuthContext } from "../../contexts/AuthContext";

// Accesos rápidos con los mismos permisos del sidebar.
const ACCESOS = [
  { label: "CRM", desc: "Prospectos, oportunidades y embudo de ventas", icon: "fas fa-handshake", color: "#2563eb", href: "/MenuCrm", perm: (u) => u.menu_crm },
  { label: "Catálogos", desc: "Telas, modelos, clientes, proveedores y talleres", icon: "fas fa-book-open", color: "#0d9488", href: "/MenuCatalogos", perm: (u) => u.menu_articulos },
  { label: "Pedidos", desc: "Cotizaciones, pedidos, entregas y ventas", icon: "fas fa-shopping-basket", color: "#2563eb", href: "/MenuVentas", perm: (u) => u.menu_ventas },
  { label: "Compras", desc: "Órdenes de compra, recepción y reportes", icon: "fas fa-cart-plus", color: "#0284c7", href: "/MenuCompras", perm: (u) => u.menu_compras },
  { label: "Muestras", desc: "Muestras a clientes y prospectos", icon: "fas fa-tshirt", color: "#db2777", href: "/Muestras", perm: (u) => u.menu_muestras },
  { label: "Producción", desc: "Órdenes de producción, cortes y procesos", icon: "fas fa-cut", color: "#7c3aed", href: "/MenuProduccion", perm: (u) => u.menu_produccion },
  { label: "Inventarios", desc: "Producto terminado, telas y habilitación", icon: "fas fa-warehouse", color: "#0d9488", href: "/MenuInventarios", perm: (u) => u.menu_inventarios },
  { label: "Admin / CxC", desc: "Ventas, cobranza y estados de cuenta", icon: "fas fa-file-invoice-dollar", color: "#16a34a", href: "/MenuAdmin", perm: (u) => u.menu_admin },
  { label: "CxP", desc: "Pagos a proveedores y talleres", icon: "fas fa-hand-holding-usd", color: "#ea580c", href: "/MenuCXP", perm: (u) => u.menu_adminCxP || u.menu_cxpPagos },
  { label: "Gastos", desc: "Conceptos, gastos y pagos", icon: "fas fa-receipt", color: "#d97706", href: "/MenuGastos", perm: (u) => u.menu_gastos },
  { label: "Colaboradores", desc: "Colaboradores y puestos", icon: "fas fa-address-card", color: "#0d9488", href: "/MenuNominas", perm: (u) => u.menu_nominas },
  { label: "Usuarios", desc: "Usuarios y permisos", icon: "fas fa-users-cog", color: "#475569", href: "/MenuUsuarios", perm: (u) => u.menu_usuarios },
];

function HomeInicio() {
  const { user } = useContext(AuthContext);

  // Los usuarios de cliente y de estado de cuenta tienen su propio menú en el sidebar
  const menuReducido = user?.tipo === "Cliente" || user?.menu_edoCta_Cliente || user?.menu_cobradores;
  const accesos = menuReducido || !user ? [] : ACCESOS.filter((a) => a.perm(user));

  const hora = new Date().getHours();
  const saludo = hora < 12 ? "Buenos días" : hora < 19 ? "Buenas tardes" : "Buenas noches";
  const fecha = new Date().toLocaleDateString("es-MX", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });

  return (
    <>
      <Header />
      <div className="container-fluid" style={{ maxWidth: 1180, padding: "8px 20px 32px" }}>
        {/* Bienvenida */}
        <div
          className="home-hero"
          style={{
            borderRadius: 16,
            padding: "28px 32px",
            marginBottom: 22,
            color: "#fff",
            background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 60%, #2563eb 100%)",
            boxShadow: "0 10px 30px rgba(30, 58, 138, 0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 20,
            flexWrap: "wrap",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <i
            className="fas fa-tshirt"
            style={{ position: "absolute", right: -10, bottom: -30, fontSize: "11rem", opacity: 0.07 }}
          />
          <div style={{ position: "relative" }}>
            <div style={{ fontSize: "0.75rem", opacity: 0.75, textTransform: "capitalize", letterSpacing: "0.03em" }}>
              {fecha}
            </div>
            <h2 style={{ margin: "6px 0 6px", fontWeight: 700, fontSize: "1.55rem", color: "#fff" }}>
              {saludo}{user?.nombre ? `, ${user.nombre}` : ""}
            </h2>
            <p style={{ margin: 0, fontSize: "0.85rem", opacity: 0.85, maxWidth: 560 }}>
              {menuReducido
                ? "Bienvenido a Langiani. Elige una opción del menú."
                : user?.menu_usuarios
                ? "Bienvenido a Langiani. Elige un módulo para empezar o pregúntale al asistente IA."
                : "Bienvenido a Langiani. Elige un módulo para empezar."}
            </p>
          </div>
          <img
            src={process.env.PUBLIC_URL + "/logoInstitucion.png"}
            alt="logo"
            style={{ maxHeight: 64, background: "#fff", borderRadius: 12, padding: "8px 12px", position: "relative" }}
          />
        </div>

        {/* Accesos rápidos */}
        {accesos.length > 0 ? (
          <div
            style={{
              fontSize: "0.66rem", fontWeight: 700, textTransform: "uppercase",
              letterSpacing: "0.09em", color: "#94a3b8", margin: "0 0 12px 2px",
            }}
          >
            Accesos rápidos
          </div>
        ) : null}
        <div className="row">
          {accesos.map((a) => (
            <div key={a.href} className="col-12 col-sm-6 col-lg-4 mb-3">
              <a
                href={a.href}
                style={{
                  display: "flex", alignItems: "center", gap: 14, padding: "18px 18px",
                  background: "#fff", borderRadius: 12, border: "1px solid #eef2f7",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.06)", textDecoration: "none", height: "100%",
                  transition: "box-shadow 0.15s, transform 0.15s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 22px rgba(15,23,42,0.10)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06)";
                  e.currentTarget.style.transform = "none";
                }}
              >
                <div
                  style={{
                    width: 48, height: 48, borderRadius: 12, flexShrink: 0,
                    background: `${a.color}14`, color: a.color,
                    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.2rem",
                  }}
                >
                  <i className={a.icon} />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: "0.9rem", color: "#0f172a" }}>{a.label}</div>
                  <div style={{ fontSize: "0.72rem", color: "#64748b", lineHeight: 1.35 }}>{a.desc}</div>
                </div>
                <i className="fas fa-chevron-right" style={{ marginLeft: "auto", color: "#cbd5e1", fontSize: "0.75rem" }} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default HomeInicio;
